"use client";

import React from "react";
import { MapPin, Phone, Mail, Map } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
const locations = [{
  id: 1,
  name: "Midtown Medical Hub",
  address: "Peachtree St NE, Atlanta, GA 30309",
  phone: "(678) 358-0270",
  email: "midtown@gotmeds.io",
  type: "primary",
  x: "50%",
  y: "50%"
}, {
  id: 2,
  name: "Decatur Care Center",
  address: "W Ponce de Leon Ave, Decatur, GA 30030",
  phone: "(678) 358-0270",
  email: "decatur@gotmeds.io",
  type: "secondary",
  x: "68%",
  y: "58%"
}, {
  id: 3,
  name: "Alpharetta Logistics",
  address: "North Point Pkwy, Alpharetta, GA 30022",
  phone: "(678) 358-0270",
  email: "alpharetta@gotmeds.io",
  type: "secondary",
  x: "45%",
  y: "15%"
}];
export default function JourneyMap() {
  return <section data-section-id="222923" id="atlanta-service-radius" className="w-full bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground md:text-4xl lg:text-5xl mb-4">
            Atlanta Service Radius
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground font-default">
            Our premium prescription network spans the entire Atlanta metro area, ensuring swift, secure delivery from top medical professionals directly to your doorstep.
          </p>
        </div>

        <div className="mx-auto w-full max-w-[1400px]">
          <div className="relative overflow-hidden rounded-2xl border border-border bg-accent/10 shadow-2xl shadow-primary/5 backdrop-blur-sm">
            <AspectRatio ratio={21 / 9} className="relative w-full bg-muted/30">
              {}
              <div className="absolute inset-0 bg-primary/5 mix-blend-multiply"></div>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651003/img/atlanta_metro_vector_map.png" alt="Atlanta Metro Service Area Map" className="absolute inset-0 h-full w-full object-cover opacity-60 mix-blend-luminosity grayscale" />

              {}
              {locations.map((loc, i) => <div key={loc.id} data-index={i} className="absolute z-10 -translate-x-1/2 -translate-y-1/2" style={{
              left: loc.x,
              top: loc.y
            }}>
                  <Popover>
                    <PopoverTrigger asChild>
                      <Button variant={loc.type === "primary" ? "default" : "secondary"} size="icon" className={`relative size-10 rounded-full shadow-lg transition-transform hover:scale-110 md:size-12 ${loc.type === "primary" ? "bg-primary text-primary-foreground ring-4 ring-primary/30" : "bg-secondary text-secondary-foreground ring-4 ring-secondary/30"}`} aria-label={`View details for ${loc.name}`}>
                        <MapPin className="size-5 md:size-6" />
                        {loc.type === "primary" && <span className="absolute inset-0 -z-10 animate-ping rounded-lg bg-primary opacity-40"></span>}
                      </Button>
                    </PopoverTrigger>
                    <PopoverContent side="top" align="center" sideOffset={12} className="w-80 border-border/50 p-5 shadow-xl bg-card/95 backdrop-blur-md">
                      <div className="space-y-4">
                        <h4 className="font-default flex items-center gap-2 border-b border-border pb-3 text-lg font-bold text-foreground">
                          <Map className={`size-5 shrink-0 ${loc.type === "primary" ? "text-primary" : "text-secondary"}`} />
                          {loc.name}
                        </h4>
                        <div className="space-y-3">
                          <div className="flex items-start gap-3 text-sm text-muted-foreground font-default">
                            <MapPin className="mt-0.5 size-4 shrink-0 text-primary/70" />
                            <span className="leading-snug">{loc.address}</span>
                          </div>
                          <div className="flex items-center gap-3 text-sm text-muted-foreground font-default">
                            <Phone className="size-4 shrink-0 text-primary/70" />
                            <span>{loc.phone}</span>
                          </div>
                          <div className="flex items-center gap-3 text-sm text-muted-foreground font-default">
                            <Mail className="size-4 shrink-0 text-primary/70" />
                            <span>{loc.email}</span>
                          </div>
                        </div>
                      </div>
                    </PopoverContent>
                  </Popover>
                </div>)}
            </AspectRatio>
          </div>
        </div>
      </div>
    </section>;
}